import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { registerMicroAppsFn } from '@/qiankun/config'
import setupPlugins from "@/plugins";

import "element-plus/theme-chalk/dark/css-vars.css";
import "@/styles/index.scss";
import './style.css';

const app = createApp(App)
app.use(setupPlugins)
app.use(router)
app.mount('#app')
registerMicroAppsFn()